
export const STATES_ATTEMPT = 'STATES_ATTEMPT';
export const STATES_SUCCESS = 'STATES_SUCCESS';
export const STATES_FAILED = 'STATES_FAILED';
